import { userService } from '@saucelabs/sl-util-axios';

export const fetchUserServiceUser = ({ id }) => (
  userService.get(`/v1/users/${id}/`)
);

export const fetchUserServiceUserByUsername = ({ username }) => (
  userService.get('/v1/users/', { username })
);
